/**
 * HistoryThumbnail — compact 64×40 SVG preview of a project snapshot.
 * Cyan rectangles for placed equipment, orange polylines for cable trays,
 * grey room outline. Used in the Elevation Views replay-history popover.
 */
export default function HistoryThumbnail({ snap, L, W }) {
  const items = (snap?.equipment_list   || []).filter((x) => x.position);
  const trays = (snap?.cable_trays || []);
  const Lpx = 64, Hpx = 40;
  const pad = 2;
  const scaleX = (L > 0) ? (Lpx - pad * 2) / L : 0;
  const scaleY = (W > 0) ? (Hpx - pad * 2) / W : 0;
  const sx = (x) => pad + x * scaleX;
  const sy = (y) => Hpx - pad - y * scaleY;
  return (
    <svg viewBox={`0 0 ${Lpx} ${Hpx}`}
         className="bg-[#050608] border border-white/10"
         style={{ width: Lpx, height: Hpx }}>
      <rect x={pad} y={pad} width={Lpx - pad * 2} height={Hpx - pad * 2}
            fill="none" stroke="#00E5FF" strokeOpacity="0.5" strokeWidth="0.6" />
      {trays.map((t, i) => {
        if (!t.points?.[0]) return null;
        const p0 = t.points[0];
        const p1 = t.points[1] || p0;
        if (t.kind === "drop" || (p0[0] === p1[0] && p0[1] === p1[1])) {
          return <circle key={`t-${i}`} cx={sx(p0[0])} cy={sy(p0[1])}
                         r="0.8" fill="#FFA500" />;
        }
        return (
          <line key={`t-${i}`} x1={sx(p0[0])} y1={sy(p0[1])}
                x2={sx(p1[0])} y2={sy(p1[1])}
                stroke="#FFA500" strokeWidth="0.7" strokeOpacity="0.85" />
        );
      })}
      {items.map((it, i) => {
        const p = it.position;
        return (
          <rect key={`e-${i}`} x={sx(p.x_in)} y={sy(p.y_in + p.h_in)}
                width={Math.max(0.6, p.w_in * scaleX)}
                height={Math.max(0.6, p.h_in * scaleY)}
                fill="#00E5FF" fillOpacity="0.35"
                stroke="#00E5FF" strokeWidth="0.4" />
        );
      })}
    </svg>
  );
}
